import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PayoutTable from "../../components/Payout/PayoutTable";
import AffiliatePayout from "../../components/Payouts/AffiliatePayout";
import TradingPayout from "../../components/Payouts/TradingPayout";
// import AlphaCreator from "../../components/Payouts/AlphaCreator.jsx"; // Make sure this file exists
import Tabination from "../../reusableComponents/Tabs";
import { useSelector } from "react-redux";
import { getAfsPayoutList } from "../../utils/apis/payments";
import "./style.scss";

function Payout() {
  const location = useLocation();
  const { idToken } = useSelector((state) => state.auth);

  const [activeTab, setActiveTab] = useState(0);
  const [afspayoutList, setAfsPayoutList] = useState([]);

  const items = [
    {
      name: "Trading Payout",
      path: "trading-payout",
    },
    {
      name: "Affiliate Payout",
      path: "affiliate-payouts",
    },
    // {
    //   name: "Alpha Creator",
    //   path: "alpha-creator",
    // },
    {
      name: "Payout History",
      path: "payout-history",
    },
  ];

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Set active tab based on URL
  useEffect(() => {
    const pathnameSegments = location.pathname.split("/");
    const currentPath = pathnameSegments[2];

    switch (currentPath) {
      case "trading-payout":
        setActiveTab(0);
        break;
      case "affiliate-payouts":
        setActiveTab(1);
        break;
      // case "alpha-creator":
      //   setActiveTab(2);
      //   break;
      case "payout-history":
        setActiveTab(2);
        break;
      default:
        setActiveTab(0);
        break;
    }
  }, [location.pathname]);

  // Fetch affiliate payout list
  const fetchPayout = async () => {
    try {
      const response = await getAfsPayoutList(idToken);
      setAfsPayoutList(response);
    } catch (error) {
      console.error("Error fetching AFS payout list:", error);
    }
  };

  useEffect(() => {
    fetchPayout();
  }, []);

  const totalAmounts = afspayoutList.reduce(
    (acc, item) => acc + (item?.amount || 0),
    0
  );

  return (
    <div className="payout_container">
      <div className="payout_header_wrapper">
        <Tabination
          variant={1}
          tabItems={items}
          showTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          mainurl="/payout/"
        />
        {/* 
        <div className="total_withdraw_status">
          <p>Total Withdrawable Amount</p>
          <p>${totalAmounts.toFixed(2)}</p>
        </div> 
        */}
      </div>

      <div className="payout_wrapper">
        <Routes>
          <Route path="/" element={<Navigate to="trading-payout" replace />} />
          <Route path="trading-payout" element={<TradingPayout />} />
          <Route
            path="affiliate-payouts"
            element={<AffiliatePayout afspayoutList={afspayoutList} />}
          />
          {/* <Route path="alpha-creator" element={<AlphaCreator />} /> */}
          <Route path="payout-history" element={<PayoutTable />} />
        </Routes>
      </div>
    </div>
  );
}

export default Payout;
